import QuestionnairesStore from '../Stores/QuestionnairesStore'
import { action } from 'mobx'
import { IProduct, Questionnaire } from '../Model/Questionnaire'
import ExportStore, { ExportType } from '../Stores/ExportStore'
import ConfigStore from '../Stores/ConfigStore'
import Setting from '../Model/Setting'
import SettingsStore from '../Stores/SettingsStore'
import { ICreditCondition } from '../Model/CreditCondition'
import { IAgentInfo } from '../Model/AgentInfo'
import { CourtDecision } from '../Model/CourtDecision'

export default class ActionsLocalService {
    private questionnairesStore = QuestionnairesStore.getInstance()
    private exportStore = ExportStore.getInstance()
    private configStore = ConfigStore.getInstance()
    private settingsStore = SettingsStore.getInstance()

    private static _instance: ActionsLocalService

    private constructor() { }

    public static getInstance(): ActionsLocalService {
        return this._instance || (this._instance = new this())
    }

    @action.bound
    updateQuestionnaireProductList(product: IProduct) {
        this.questionnairesStore.updateProductList(product)
    }

    @action.bound
    initQ() {
        this.questionnairesStore.setItem(new Questionnaire())
    }

    @action.bound
    updateQ(q: Questionnaire) {
        this.questionnairesStore.setItem(q)
    }

    @action.bound
    setExportData(exportType: ExportType, items: Array<any>) {
        this.exportStore.setItems(exportType, items)
    }

    @action.bound
    setPageSize(pageSize: number) {
        this.configStore.setPageSize(pageSize)

        window.location.reload()
    }

    @action.bound
    setSettingToDelete(key: string | null) {
        let setting: Setting | null | undefined = null

        if (key) {
            setting = this.settingsStore.getSettings.find(x => x.key === key)
        }

        this.settingsStore.setSettingToDelete(setting)
    }

    @action.bound
    updateCreditConditionInQ(condition: ICreditCondition) {
        this.questionnairesStore.updateCreditCondition(condition)
    }

    @action.bound
    updateAgentInfoInQ(agentInfo: IAgentInfo) {
        this.questionnairesStore.updateAgentInfo(agentInfo)
    }

    @action.bound
    updateCourtDecisionInQ(courtDecision: CourtDecision) {
        this.questionnairesStore.updateCourtDecision(courtDecision)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Services/ActionsLocalService.ts